@if (trendLineData$ | async; as trendLineData) {
  @if (isSuccessResponse(trendLineData)) {
    <mat-card class="graph-card">
      <mat-card-header class="table-header">
        <mat-card-title class="table-title">{{ 'BFP.UI.TrendlineData.Title' | translate }}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="graphs-row">
          <ng-container
            *ngTemplateOutlet="chart; context: { dataSource: leafWeightChartData, options: leafWeightChartOptions }"
          />
          <ng-container
            *ngTemplateOutlet="chart; context: { dataSource: nitrateChartData, options: nitrateChartOptions }"
          />
        </div>
        <div class="graph-description-content">
          <div class="title-container">
            <h3>{{ 'BFP.UI.TrendlineData.DescriptionTitle' | translate }}</h3>
            <hr class="title-bottomline" />
          </div>
          <p>
            {{ `BFP.UI.TrendlineData.Descriptions.${trendLineData.chartTextCode ?? 'G0'}` | translate }}
          </p>
        </div>
      </mat-card-content>
    </mat-card>
  } @else {
    <!-- Error state -->
    <mat-card class="error-card">
      <mat-card-content>
        <agr-notification-empty
          [isEmpty]="true"
          [emptyDescription]="'BFP.UI.TrendlineData.Error' | translate"
          [showEmptyAction]="false"
          emptyActionColor="primary"
        />
      </mat-card-content>
    </mat-card>
  }
} @else {
  <!-- Loading state -->
  <mat-card class="loading-card">
    <mat-card-content>
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'BFP.UI.Loading' | translate }}</span>
      </div>
    </mat-card-content>
  </mat-card>
}

<ng-template #chart let-dataSource="dataSource" let-options="options">
  @if (dataSource?.length) {
    <div class="graph-container">
      <agr-chart [dataSource]="dataSource" [options]="options" [extendDefaults]="true" />
    </div>
  } @else {
    <div class="no-data-container">
      <agr-notification-empty
        [isEmpty]="true"
        [emptyDescription]="'BFP.UI.TrendlineData.NoData' | translate"
        [showEmptyAction]="false"
        emptyActionColor="primary"
      />
    </div>
  }
</ng-template>
